import {useEffect, useMemo, useState} from 'react';
import './FormulatrixPage.scss';
import {FmlxIcon} from 'fmlx-common-ui';
import {getFormulatrixFeedback} from '../../stores/business/feedbackReviewBusiness';
import {
  ColumnAccessorEnum,
  FeedbackFormulatrixConfig,
  FormulatrixFeedbackEnum,
  PaginationEnum,
} from '../../const/dataEnum';
import FeedbackModal from './FeedbackReviewModal/FeedbackModal';
import EssSimpleTable from '../../components/MessageTable/TableColumn/EssSimpleTable';
import {getSortedAndSlicedData} from '../../lib/filterHelper';
import {useDataProcessor} from '../../hooks/useDataProcessor';
import {useColumnFormat} from '../../hooks/useColumnFormat';
import {usePagination} from '../../hooks/usePagination';

const FeedbackFormulatrixPage = ({periodId}) => {
  const [feedback, setFeedback] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [dataPerColumn, setDataPerColumn] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const {dataState} = useDataProcessor(feedback, 0, FeedbackFormulatrixConfig);
  const {columnFormat} = useColumnFormat(ColumnAccessorEnum);
  const {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    pageOptions,
    MemoizedEmptyRows,
    handleSort,
    sortConfig,
  } = usePagination(dataState, {}, PaginationEnum.PAGE_OPTIONS);

  const ActionIcon = Object.freeze({
    ACTIONS: {
      id: 'actions',
      accessor: 'employeSentTab',
      Cell: ({row}) => (
        <div style={{cursor: 'pointer'}} onClick={() => handleOnClick(row)}>
          <FmlxIcon name={'Eye'} />
        </div>
      ),
    },
  });

  const generateTableColumns = [
    FormulatrixFeedbackEnum.TEAM_MEMBER,
    FormulatrixFeedbackEnum.TEAM,
    FormulatrixFeedbackEnum.ROLE,
    FormulatrixFeedbackEnum.PRACTICE,
    FormulatrixFeedbackEnum.COMMENTS,
    ActionIcon.ACTIONS,
  ];

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const result = await getFormulatrixFeedback(periodId);
        if (result) {
          setFeedback(result);
        }
      } catch (error) {
        console.error('Error fetching feedback:', error);
      }
    };
    fetchFeedback();
    setDataPerColumn(generateTableColumns);
  }, [periodId]);

  const handleOnClick = (feedback) => {
    setSelectedFeedback(feedback);
    setIsOpen(true);
  };

  const handleOnClose = () => {
    setIsOpen(false);
    setSelectedFeedback(null);
  };

  const memoizedSlicedData = useMemo(() => {
    return getSortedAndSlicedData(feedback, sortConfig, page, rowsPerPage);
  }, [feedback, sortConfig, page, rowsPerPage]);

  return (
    <div className="formulatrix-table-wrapper">
      <EssSimpleTable
        isCollapsible={false}
        columnData={dataPerColumn}
        columns={columnFormat}
        onSort={handleSort}
        sortTableDirection={sortConfig.direction}
        sortKey={sortConfig.key}
        filteredData={memoizedSlicedData}
        renderEmptyData={MemoizedEmptyRows}
        dataCount={dataState}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onPageOption={pageOptions}
      />
      {selectedFeedback && <FeedbackModal open={isOpen} onClose={handleOnClose} selectedFeedback={selectedFeedback} />}
    </div>
  );
};

export default FeedbackFormulatrixPage;
